export default {
  message: {
    title:{
      HomeTitle:"KuDee-This is an innovative Layer2 public chain",
      Download:"KuDee-This is an innovative Layer2 public chain",
      AboutUs:"KuDee-This is an innovative Layer2 public chain",
      News:"KuDee-This is an innovative Layer2 public chain",
      NewsDetails:"KuDee-This is an innovative Layer2 public chain",
      Company:"KuDee-This is an innovative Layer2 public chain",
      AndroidProcess:"KuDee-This is an innovative Layer2 public chain",
      IOSProcess:"KuDee-This is an innovative Layer2 public chain",
    },
    zh:"Chinese (Simplified)",
    en:'English',
    kor:'Korean',
    i18:'English',
    headerMenu_home:'Home',
    headerMenu_news:'News',
    headerMenu_download:'Download',
    headerMenu_aboutUs:'AboutUs',

    homeTitle1:'Make digital currency available everywhere',
    homeTitle2:'Use DAO to manage your wallet and keep security with you. The largest decentralized wallet on the KuDee public chain.',
    Android:'Android',
    Ios:'IOS(Super Visa)',
    AndroidGeneral:'Android (Universal)',
    Version:'Version',
    UpdateTime:'Update time',
    IOSSuper:'IOS(Super Signature)',
    homeTitle3:'We protect your digital assets',
    homeTitle4:'Your digital assets will be stored on the blockchain network, and each asset will be protected by blockchain technology',
    homeTitle5:'Secure Access',
    homeTitle6:'Assets are put on the chain, anonymous asset management, and asset security is guaranteed',
    homeTitle7:'Simple transactions',
    homeTitle8:'Anytime, anywhere, let your digital assets be easily traded, whether it is transfer, cross-chain or other',
    homeTitle9:'Multi-chain management',
    homeTitle10:'Easily access on-chain tokens, supporting KuDee, BSC, Polygon, TRON and other blockchain networks',
    homeTitle11:'Our latest news and information',
    homeTitle12:'We promote our blockchain business and products around the world, and we will publish the latest news and consultations',
    homeTitle13:'Make digital currency\n available everywhere',
    homeTitle14:'*Important statement: Currently, KuDee Wallet is only subject to the jurisdiction and supervision of the United States and has obtained permission from relevant regulatory authorities.',
    homeTitle15:'Social Media',
    homeTitle16:'KUDEE WALLET download address',
    homeTitle17:'KuDee Wallet is a self-hosted wallet that supports multiple chains. It is simple and safe to use and is trusted and loved by tens of millions of people around the world.',
    homeTitle18:'*Please download the wallet app from the official website and check the website’s SSL certificate',
    homeTitle19:'*Please do not trust others to borrow your account and password',
    homeTitle20:'*User assets are all on-chain, please keep the relevant certificate information properly',
    homeTitle21:'*Protect your private key and mnemonic phrase, do not disclose them to anyone',
    homeTitle22:'*Learn more safety knowledge',
    homeTitle23:'Latest version',
    homeTitle24:'How to verify the authenticity of a wallet app?',
    AboutUsTitle1:'about Us',
    AboutUsTitle2:'Here you can quickly find us',
    AboutUsTitle3:'Company Information',
    AboutUsTitle4:'We are registered in many countries and regions, and we are always committed to operating legally and in compliance with regulations.',
    AboutUsTitle5:'1. Australian Headquarters: Global Strategic Operations Center',
    AboutUsTitle6:'2. US Branch: Token Operation and Compliance Management',
    AboutUsTitle7:'3. UK branch: global technical support and R&D support',
    AboutUsTitle8:'4. Canadian company: Global node operation and maintenance center',
    AboutUsTitle9:'*Click here for company information details.',
    AboutUsTitle10:'You can contact us and seek business cooperation through the following methods.',
    AboutUsTitle11:'Official media',
    homeTitle25:'Get Google Authenticator',
    News1title:'KuDee public chain officially launched, entering the public chain field',
    News1time:'February 2024',
    News1Introduction:'The company\'s core development members come from Internet companies such as Google, Microsoft, and Binance, and have rich development experience.',
    News2title:"KuDee public chain team launches public chain ecological series products",
    News2time:'December 2024',
    News2Introduction:'Launched core ecological products such as KuEX App and KuDee public chain browser.',
    News3title:'KuEX APP is officially launched and integrates multiple new features',
    News3time:'January-March 2025',
    News3Introduction:'KuEX App includes wallet, DAPP, exchange, social and entertainment functions.',


    Process1:'One public chain, countless miracles！',
    Process2:'Android Download',
    Process3:'Iphone Download',
    Process4:'Scroll down to view tutorial',
    Process5:'Operation process',
    Process6:'Click the "Download" button',
    Process7:'Click "Download and Install"',
    Process8:'Click on "Install"',
    Process9:'Click "Trust Now"',
    Process10:'Click "Allow"',
    Process11:'Click "Trust this app"',
    Process12:'Click "Trust MOST INC EOOD"',
    Process13:'Click Trust this app',
    Process14:'Using blockchain technology to create a better financial world',
  }
}
